import request from '@u/request'

// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
		method: 'POST',
		data: data || {}
	})
}

// 查询订单
export function orderList(data){
	return request({
		url: '/cms_shengya/orderList',
        method: 'POST',
        data: data || {}
	})
}

// 查询商品
export function buyList(data){
	return request({
		url: '/cms_shengya/buyList',
        method: 'POST',
        data: data || {}
	})
}

// 测评统计
export function cepingAnalysis(data){
	return request({
		url: '/cms_shengya/cepingAnalysis',
        method: 'POST',
        data: data || {}
	})
}

